import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Hero from "@/components/marketing/Hero";
import MarqueeBar from "@/components/marketing/Marquee";
import About from "@/components/marketing/About";
import ServiceCards from "@/components/marketing/ServiceCards";
import Projects from "@/components/marketing/Projects";
import Asphalt from "@/components/marketing/Asphalt";
import Careers from "@/components/marketing/Careers";
import Newsletter from "@/components/marketing/Newsletter";
import EstimatingCTA from "@/components/marketing/EstimatingCTA";
import Reveal from "@/components/Reveal";
import { trackEvent } from "@/lib/tracking";
import { SERVICE_CATEGORIES } from "@/data/content";

export default function Home() {
  useEffect(() => {
    trackEvent("page_view", { label: "home" });
  }, []);

  return (
    <div id="home" data-testid="home-page">
      <Hero />
      <MarqueeBar />
      <About />

      {/* Services — flip cards */}
      <section id="services" data-testid="home-services" className="bg-rc-charcoal py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal trackLabel="services" className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
            <div>
              <div className="font-mono text-rc-sand text-xs uppercase tracking-[0.3em] mb-5">02 — Capabilities</div>
              <h2 className="font-heading font-black text-white leading-[0.95] text-[clamp(2rem,5vw,4rem)] tracking-tight">
                Our expertise,
                <br />
                your infrastructure.
              </h2>
            </div>
            <Link
              to="/services"
              data-testid="home-view-services"
              className="inline-flex items-center gap-2 border-2 border-white/40 text-white px-7 py-3.5 rounded-full font-bold uppercase tracking-[0.12em] text-sm hover:bg-white hover:text-rc-charcoal transition-colors whitespace-nowrap"
            >
              Explore Services <ArrowRight size={17} />
            </Link>
          </Reveal>
          <ServiceCards services={SERVICE_CATEGORIES} categoryCards />
        </div>
      </section>

      <Projects />
      <Asphalt />
      <Careers />
      <Newsletter />
      <EstimatingCTA />
    </div>
  );
}
